import {Component, effect, OnInit} from '@angular/core';
import {
    CatalogoInterface,
    ColindanteItem,
    DistritoItem,
    ElementosTerrenoItem,
    MunicipioItem,
} from '../../../../../interfaces/proyecto.interface';
import {NuevoProyectoService} from '../../services/nuevo-proyecto.services';
import {NuevoProyectoComponent} from '../../nuevo-proyecto.component';
import {catchError, throwError} from 'rxjs';
import {MessageService} from 'primeng/api';
import {
    isAlphaNumericValidEvent,
    isValidLatitude,
    isValidLongitude
} from "../../../../../../shared/services/utils-service";
import {LoginServices} from "../../../../../../auth/login/services/login.service";
import {CatalogoService} from "../../../../../../shared/services/catalogo-service";
import {DraftProjectService} from "../../../../services/draft-project.service";

@Component({
    selector: 'ubicacion-proyecto',
    templateUrl: './ubicacion-proyecto.component.html',
    styleUrls: ['./ubicacion-proyecto.component.css']
})
export class UbicacionProyectoComponent implements OnInit {
    constructor(private messageService: MessageService, private catalogoService: CatalogoService, private nuevoProyectoService: NuevoProyectoService,
                protected datosProyecto: NuevoProyectoComponent, private loginServices: LoginServices, protected draftProjectService : DraftProjectService) {
    }

    coberturasVegetal: CatalogoInterface[] = []
    elementosTerrenos: CatalogoInterface[] = []
    relieves: CatalogoInterface[] = []
    departamentos: CatalogoInterface[] = []
    distritos: DistritoItem[] = []
    municipios: MunicipioItem[] = []
    opcionesUbicacion: CatalogoInterface[] = []
    ubicacionSeleccionada: CatalogoInterface = null!
    nombreColindante: string = null!
    onpenLeaflet:boolean = false;

    ngOnInit(): void {
        this.catalogoService.getCatalogo('cobertura')
            .pipe(
                catchError(error => {
                    const status = error.status
                    if (status == '400' || status == '404') {
                        this.messageService.add({
                            severity: 'error',
                            summary: '',
                            detail: 'Error al obtener la información de coberturas'
                        });
                    }
                    return throwError(error.statusText);
                })
            )
            .subscribe(
                resp => {
                    this.coberturasVegetal = resp
                },
            )
        this.catalogoService.getCatalogo('elemento_terreno')
            .pipe(
                catchError(error => {
                    const status = error.status
                    if (status == '400' || status == '404') {
                        this.messageService.add({
                            severity: 'error',
                            summary: '',
                            detail: 'Error al obtener la información elementos de terreno'
                        });
                    }
                    return throwError(error.statusText);
                })
            )
            .subscribe(
                resp => {
                    this.elementosTerrenos = resp
                },
            )
        this.catalogoService.getCatalogo('relieve')
            .pipe(
                catchError(error => {
                    const status = error.status
                    if (status == '400' || status == '404') {
                        this.messageService.add({
                            severity: 'error',
                            summary: '',
                            detail: 'Error al obtener la información de relieve'
                        });
                    }
                    return throwError(error.statusText);
                })
            )
            .subscribe(
                resp => {
                    this.relieves = resp
                },
            )
        this.catalogoService.getCatalogo('colindante')
            .pipe(
                catchError(error => {
                    const status = error.status
                    if (status == '400' || status == '404') {
                        this.messageService.add({
                            severity: 'error', summary: '', detail: 'Error al obtener la información de colindantes'
                        });
                    }
                    return throwError(error.statusText);
                })
            )
            .subscribe(
                resp => {
                    this.opcionesUbicacion = resp
                },
            )
        this.catalogoService.getCatalogo('departamento')
            .pipe(
                catchError(error => {
                    const status = error.status
                    if (status == '400' || status == '404') {
                        this.messageService.add({
                            severity: 'error', summary: '', detail: 'Error al obtener la información de departamentos'
                        });
                    }
                    return throwError(error.statusText);
                })
            )
            .subscribe(
                resp => {
                    this.departamentos = resp
                },
            )
    }

    /*
     gets
     */
    get camposCompletos() {
        return this.datosProyecto.datosCompletosUbicacion
    }

    /*
     sets
     */
    setArreaTerreno(area: string) {
        if (/^[0]+$/.test(area)) {//validacion para que solo permita un 0
            this.datosProyecto.areaTerreno = "0"
        } else {
            this.datosProyecto.areaTerreno = area
            if (!isNaN(parseInt(this.datosProyecto.areaTerreno))) {
               this.draftProjectService.draftProject.update(draft=>({
                    ...draft,
                    areas: [{
                        area: Number.parseInt(this.datosProyecto.areaTerreno!),
                        idProyecto: 0,
                        idTipoArea: 1,
                        eliminado: null,
                        idSolicitudDetalle: 0,
                        creadoPor: this.loginServices.session()?.perfil?.usuario,
                        fechaCreacion: null,
                        estado: null,
                        fechaModificacion: null
                    }]
                }));
            }
        }
    }

    setDepartamento(departamento: any) {
       this.draftProjectService.draftProject.set({
            ...this.draftProjectService.draftProject(),
            departamento: {...departamento}
        });

    }

    setDistrito(distrito: DistritoItem) {
       this.draftProjectService.draftProject.set({
            ...this.draftProjectService.draftProject(),
            distrito: {...distrito}
        });
    }

    setElementoTerreno(elementosTerrenoItem: ElementosTerrenoItem[]) {
       this.draftProjectService.draftProject.update(draft=>({
            ...draft,
            elementosTerreno: [...elementosTerrenoItem]
        }));
    }

    setCobertura(idCobertura: string) {
        this.draftProjectService.draftProject.set({
            ...this.draftProjectService.draftProject(),
            idCobertura: idCobertura
        });

    }

    setRelieve(idRelieve: string) {
        this.draftProjectService.draftProject.set({
            ...this.draftProjectService.draftProject(),
            idRelieve: idRelieve
        });
    }

    setUbicacionItemMatricula(value: string) {
        console.log(`matricula -> ${JSON.stringify(value)}`)
    }

    setUbicacionItemClaveCatastral(value: string) {
        console.log(`claveCatastral -> ${JSON.stringify(value)}`)
    }

    setUbicacionItemLatitud(value: string) {
        console.log(`latitud -> ${JSON.stringify(value)}`)
    }

    setUbicacionItemLongitud(value: string) {
        console.log(`longitud -> ${JSON.stringify(value)}`)
    }

    /*
     Effects
     */
    departamentoEffect = effect(() => {
        if (this.draftProjectService.draftProject().departamento != null && !isNaN(parseInt(this.draftProjectService.draftProject().departamento.id))) {
            this.getDistritos(parseFloat(this.draftProjectService.draftProject().departamento.id!));
        }
    }, {allowSignalWrites: true});

    distritoEffect = effect(() => {
        if (this.draftProjectService.draftProject().distrito != null && !isNaN(this.draftProjectService.draftProject().distrito.idDistrito)) {
            this.getMunicipios(this.draftProjectService.draftProject().distrito.idDistrito!)
        }
    }, {allowSignalWrites: true});

    /*
     Request
     */
    getDistritos(idDepartamento: number) {
        this.nuevoProyectoService.getDistritos(idDepartamento)
            .pipe(
                catchError(error => {
                    const status = error.status
                    if (status == '400' || status == '404') {
                        this.messageService.add({
                            severity: 'error',
                            summary: '',
                            detail: 'Error al obtener la información de distritos'
                        });
                    }
                    return throwError(error.statusText);
                })
            )
            .subscribe(
                resp => {
                    if (resp.status == 200) {
                        this.distritos = resp.body!
                    }
                },
            )
    }

    getMunicipios(idDistrito: number) {
        this.nuevoProyectoService.getMunicipios(idDistrito)
            .pipe(
                catchError(error => {
                    const status = error.status
                    if (status == '400' || status == '404') {
                        this.messageService.add({
                            severity: 'error', summary: '', detail: 'Error al obtener la información de municipios'
                        });
                    }
                    return throwError(error.statusText);
                })
            )
            .subscribe(
                resp => {
                    if (resp.status == 200) {
                        this.municipios = resp.body!
                    }
                },
            )
    }

    agregarColindante() {
        console.log('agregarColindante')
        if (this.ubicacionSeleccionada != null && this.nombreColindante != null && this.nombreColindante != "") {
            let colindante: ColindanteItem = {
                nombreColindante: this.nombreColindante,
                ubicacion: this.ubicacionSeleccionada.descripcion!,
                idColindante: parseFloat(this.ubicacionSeleccionada.id)!
            }
            this.draftProjectService.draftProject.update(draft => ({
                ...draft, colindantes: [...draft.colindantes, colindante]
            }));
            this.nombreColindante = null!
            this.ubicacionSeleccionada = null!
        }
    }

    eliminarColindante(indice: number) {
        this.draftProjectService.draftProject.update(draft => ({
            ...draft, colindantes: draft.colindantes.filter((_, i) => i !== indice)
        }));
    }

    isNumericValid(event: KeyboardEvent) {
        if (event.key) {
            isAlphaNumericValidEvent(event, 1);
        }
    }

    isCharactersValid(event: KeyboardEvent, call: number) {
        if (event.key) {
            isAlphaNumericValidEvent(event, call);
        }
    }

    viewLeafletMap() {
        this.onpenLeaflet = true;
    }
    onCloseLeaflet(event: boolean) {
       this.onpenLeaflet = event;
    }
    ngOnDestroy() {
        console.log(`ngOnDestroy() ->` + this.constructor.name)
    }

    protected readonly isValidLongitude = isValidLongitude;
    protected readonly isValidLatitude = isValidLatitude;
}
